import each from 'lodash/each'

function getActiveProduct(productList, engineName) {
    let currentProduct = '';
    if( productList.length > 1){
        // Если продуктов больше 1
        each(productList, function (item, key) {
            if( item.engineName === engineName){
                currentProduct = item;
            }
        });
        if(currentProduct === ''){
            // TODO: Залогировать ошибку то что нет продукта
        }

    }else{
        // Если продукт 1
        if(productList[0].engineName === engineName){
            currentProduct = productList[0];
        }else{
            // TODO: Залогировать ошибку то что нет продукта
        }
    }
    return currentProduct;
}



function transformProduct(product){
    let productObject = {};
    productObject.minAmount = product.minAmount;
    productObject.maxAmount = product.maxAmount;

    productObject.minTerm = product.minTerm;
    productObject.maxTerm = product.maxTerm;

    productObject.Interest = product.annualInterest;
    productObject.productId = product.id;

    return productObject;
}
export default {
    getActiveProduct,
    transformProduct
}